import { changePassword, updateProfile } from './api';
import type { Profile } from './types';

export const updateProfileMutation = () => ({
  mutationFn: (data: Partial<Profile>) => updateProfile(data),
});

export const changePasswordMutation = () => ({
  mutationFn: (data: { old_password: string; new_password: string; confirm_password: string }) =>
    changePassword(data),
});
